import { BACKEND_URL_PREFIX } from "../utils/const";
import { NETWORK_REQUEST_SENT, STRUCTURE_FETCH_STARTED, STRUCTURE_FETCH_COMPLETED } from "./types";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";

export const structure = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: STRUCTURE_FETCH_STARTED });

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/organization`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      dispatch({
        type: STRUCTURE_FETCH_COMPLETED,
        structure: await response.json(),
      });
    } else {
      dispatch({ type: STRUCTURE_FETCH_COMPLETED, structure: [] });
    }
  }
};
